import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  ALL,
} from '@app/Seller/accessTokens'
import {
  BALANCE_BASE,
  BALANCE_PAYMENTS_LIST,
  BALANCE_LIST,
  BALANCE_LIQPAY_SUCCESS,
} from '@app/Seller/Balance/accessTokens'

const BalanceBase = () => import('@app/Seller/Components/Base')
const BalanceList = () => import('@app/Seller/Balance/List')
const PaymentsList = () => import('@app/Seller/Balance/Bill/List')
const ReportsList = () => import('@app/Seller/Balance/Reports/List')
const LiqpaySuccess = () => import('@app/Seller/Balance/LiqpaySuccess')

const MODEL = 'balance'

const BASE = `${MODEL}/`
// const u = url => BASE + url

const LIST = ''
const PAYMENTS_LIST = 'payments/'
const REPORTS_LIST = 'reports/'
const LIQPAY_SUCCESS = 'liq-pay/success/'

export const BALANCE_PREFIX = `${MODEL}:`
const p = name => BALANCE_PREFIX + name

export const BALANCE_BASE_NAME = p('base')
export const BALANCE_LIST_NAME = p('list')
export const BALANCE_REPORTS_LIST_NAME = p('reports:list')
export const BALANCE_PAYMENTS_LIST_NAME = p('payments:list')
export const BALANCE_LIQPAY_SUCCESS_NAME = p('liqpay:success')

export function createRoutes(options) {
  return [
    route(BASE, BalanceBase, BALANCE_BASE_NAME, {
      meta: accessPermission(BALANCE_BASE, options),
      redirect: { name: BALANCE_LIST_NAME },
      children: [
        route(LIST, BalanceList, BALANCE_LIST_NAME, {
          meta: accessPermission(BALANCE_LIST, options),
        }),
        route(PAYMENTS_LIST, PaymentsList, BALANCE_PAYMENTS_LIST_NAME, {
          meta: accessPermission(BALANCE_PAYMENTS_LIST, options),
        }),
        route(REPORTS_LIST, ReportsList, BALANCE_REPORTS_LIST_NAME, {
          meta: accessPermission(ALL, options),
        }),
        route(LIQPAY_SUCCESS, LiqpaySuccess, BALANCE_LIQPAY_SUCCESS_NAME, {
          meta: accessPermission(BALANCE_LIQPAY_SUCCESS, options),
        }),
      ],
    }),
  ]
}
